export const locale = {
  lang: 'tr',
  data: {
    'CHANGELOG': {
      'TITULO': 'Değişiklik günlüğü',
      'SUBTITULO': 'Zaman içinde platformda yapılan güncellemeleri kontrol edin',
      'ULTIMA': 'Son Güncelleme',
      'CATEGORIAS': {
        'Changed': 'Güncellemeler',
        'Fixed': 'Düzeltmeler',
        'Added': 'İyileştirmeler'
      }
    },
    'KNOWLEDGE': {
      'LINK': 'Platform sizi otomatik olarak yönlendirmezse bu bağlantıya tıklayın'
    }
  }
};
